import React, { useState } from "react";
import "../../Styles/Profile.css";
import { Table } from "react-bootstrap";
import { Formik } from "formik";
import { toast } from "sonner";
import { changePassword } from "../../services/axios/apiManager";
import { passwordSchema } from "./profileValidations";
import LoadingSpinner from "../../Components/spinner";
import { handleErrors } from "../../services/dataManager";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../services/context";

const ChangePassword = ({ empData }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  return (
    <div className="tab-pane" id="changePassword" role="tabpanel">
      <div className="card-header">
        <h6 className="card-title mb-0">Changes Password</h6>
      </div>
      <div className="card-body">
        <Formik
          initialValues={{
            id: empData?.id || "",
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
          }}
          validationSchema={passwordSchema}
          onSubmit={async (values) => {
            try {
              setLoading(true);
              if (empData?.id) {
                const data = {
                  id: empData.id,
                  password: values.oldPassword,
                  newPassword: values.newPassword,
                };
                const res = await changePassword(data);
                if (res?.data?.success) {
                  toast.success("Your Password has been updated", {
                    duration: 2000,
                  });
                } else {
                  handleErrors(res, navigate, "Change Password:");
                }
              }
            } catch (error) {
              console.log("Error upon Change Password", error);
            } finally {
              setLoading(false);
            }
          }}
        >
          {({ handleChange, handleSubmit, values, errors, touched }) => (
            <div className="row g-2 justify-content-lg-between align-items-center">
              <div className="col-lg-4">
                <div className="auth-pass-inputgroup">
                  <label htmlFor="oldpasswordInput" className="form-label">
                    Old Password*
                  </label>
                  <div className="position-relative">
                    <input
                      type="password"
                      className="form-control password-input bg-dark text-light border-light input-placeholder-light form-control"
                      id="oldpasswordInput"
                      placeholder="Enter current password"
                      value={values.oldPassword}
                      onChange={handleChange("oldPassword")}
                    />
                    <button
                      className="btn btn-link position-absolute top-0 end-0 text-decoration-none text-secondary password-addon"
                      type="button"
                    >
                      <i className="ri-eye-fill align-middle" />
                    </button>
                  </div>
                  {errors?.oldPassword && touched?.oldPassword ? (
                    <span className="text-danger">{errors?.oldPassword}</span>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-4">
                <div className="auth-pass-inputgroup">
                  <label htmlFor="password-input" className="form-label">
                    New Password*
                  </label>
                  <div className="position-relative">
                    <input
                      type="password"
                      className="form-control password-input bg-dark text-light border-light input-placeholder-light form-control"
                      id="password-input"
                      placeholder="Enter new password"
                      aria-describedby="passwordInput"
                      pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                      value={values.newPassword}
                      onChange={handleChange("newPassword")}
                    />
                    <button
                      className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-secondary password-addon"
                      type="button"
                    >
                      <i className="ri-eye-fill align-middle" />
                    </button>
                  </div>
                  {errors?.newPassword && touched?.newPassword ? (
                    <span className="text-danger">{errors?.newPassword}</span>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-4">
                <div className="auth-pass-inputgroup">
                  <label
                    htmlFor="confirm-password-input"
                    className="form-label"
                  >
                    Confirm Password*
                  </label>
                  <div className="position-relative">
                    <input
                      type="password"
                      className="form-control password-input bg-dark text-light border-light input-placeholder-light form-control"
                      id="confirm-password-input"
                      placeholder="Confirm password"
                      pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                      value={values.confirmPassword}
                      onChange={handleChange("confirmPassword")}
                    />
                    <button
                      className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-secondary password-addon"
                      type="button"
                    >
                      <i className="ri-eye-fill align-middle" />
                    </button>
                  </div>
                  {errors?.confirmPassword && touched?.confirmPassword ? (
                    <span className="text-danger">
                      {errors?.confirmPassword}
                    </span>
                  ) : null}
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <a
                  href={"/forgot-password?redirect=true"}
                  className="link-danger text-decoration-underline"
                >
                  Forgot Password ?
                </a>
                <div className="mt-2">
                  {loading ? (
                    <LoadingSpinner size="lg" />
                  ) : (
                    <button
                      className="btn btn-success"
                      type="button"
                      onClick={() => {
                        console.log("pressed :");

                        handleSubmit();
                      }}
                    >
                      Change Password
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
        </Formik>
        <div className="mt-4 mb-4 pb-3 border-bottom d-flex justify-content-between align-items-center">
          <h5 className="card-title mb-0">Login History</h5>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="table-responsive">
              <Table className="table mb-0 table-dark table-hover table-striped align-middle table-borderless table-dark">
                <thead className="table-dark">
                  <tr>
                    <th scope="col">Device</th>
                    <th scope="col">IP Address</th>
                    <th scope="col">Date</th>
                    <th scope="col">Location</th>
                    <th scope="col">
                      <i className="ri-logout-box-r-line" />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <i className="bi bi-phone align-baseline me-1" />
                      iPhone 12 Pro
                    </td>
                    <td>192.44.234.160</td>
                    <td>18 Dec, 2023</td>
                    <td>Calgary, Canada</td>
                  </tr>
                  <tr>
                    <td>
                      <i className="bi bi-tablet align-baseline me-1" />
                      Apple iPad Pro
                    </td>
                    <td>192.44.234.162</td>
                    <td>03 Jan, 2023</td>
                    <td>Calgary, Canada</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ChangePassword;
